import React, { useState } from 'react';
import { useRecruitmentCounts } from '../context/RecruitmentCountsContext';

const menuItems = [
  ['overview', 'grid', 'Overview'],
  ['job-openings', 'briefcase', 'Job Openings'],
  ['add-job', 'plus', 'Add New Job'],
  ['bulk-upload', 'upload', 'Bulk Upload Jobs'],
  ['applications', 'users', 'Applications'],
  ['master', 'layers', 'Master'],
  ['mail-ids', 'mail', 'Mail IDs'],
  ['culture', 'heart', 'Culture Content'],
  ['career-banner', 'building', 'Careers Banner'],
];

const paths = {
  grid: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  briefcase: 'M9 6V4h6v2m-9 0h12a2 2 0 012 2v9a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2zm-2 5h10M10 11v2h4v-2',
  plus: 'M12 5v14M5 12h14',
  upload: 'M12 16V4m0 0L7 9m5-5l5 5M5 20h14',
  users: 'M16 20v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2m7-10a4 4 0 100-8 4 4 0 000 8zm13 10v-2a4 4 0 00-3-3.87m-2-11.96a4 4 0 010 7.75',
  building: 'M4 21V5l8-3 8 3v16M9 21v-5h6v5M8 8h.01M12 8h.01M16 8h.01M8 12h.01M12 12h.01M16 12h.01',
  pin: 'M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1116 0zm-8 3a3 3 0 100-6 3 3 0 000 6z',
  layers: 'M12 2L2 7l10 5 10-5-10-5zM2 12l10 5 10-5M2 17l10 5 10-5',
  heart: 'M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 00-7.8 7.8l1.1 1.1L12 21l7.7-7.5 1.1-1.1a5.5 5.5 0 000-7.8z',
  mail: 'M4 5h16v14H4zM4 7l8 6 8-6',
  trash: 'M3 6h18M8 6V4h8v2m2 0l-1 14H7L6 6m4 4v6m4-6v6',
  chevronDown: 'M6 9l6 6 6-6',
};

function Icon({ name }) {
  return <svg className="nav-icon" viewBox="0 0 24 24" aria-hidden="true"><path d={paths[name]} /></svg>;
}

const badgeKeys = { 'job-openings': 'jobs', applications: 'applications' };

function Sidebar({ collapsed, active, onSelect }) {
  const { counts } = useRecruitmentCounts();
  const [binOpen, setBinOpen] = useState(active === 'opening-bin' || active === 'application-bin');
  const binActive = active === 'opening-bin' || active === 'application-bin';
  return (
    <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
      <div className="sidebar-label">RECRUITMENT</div>
      <nav aria-label="Recruitment navigation">
        <ul>
          {menuItems.map(([key, icon, label]) => (
            <li key={key}>
              <button
                className={active === key ? 'active' : ''}
                onClick={() => onSelect(key)}
                title={collapsed ? label : undefined}
              >
                <Icon name={icon} />
                <span>{label}</span>
                {badgeKeys[key] && counts[badgeKeys[key]] > 0 && <em>{counts[badgeKeys[key]]}</em>}
              </button>
            </li>
          ))}
          <li className="sidebar-dropdown">
            <button
              type="button"
              className={binActive ? 'active' : ''}
              onClick={() => setBinOpen(open => !open)}
              title={collapsed ? 'Bin' : undefined}
              aria-expanded={binOpen}
            >
              <Icon name="trash" />
              <span>Bin</span>
              {!collapsed && <span className={`sidebar-dropdown-arrow${binOpen ? ' open' : ''}`}><Icon name="chevronDown" /></span>}
            </button>
            {binOpen && !collapsed && <ul className="sidebar-submenu">
              <li><button type="button" className={active === 'opening-bin' ? 'active' : ''} onClick={() => onSelect('opening-bin')}><span>Job Openings Bin</span>{counts.deletedJobs > 0 && <em>{counts.deletedJobs}</em>}</button></li>
              <li><button type="button" className={active === 'application-bin' ? 'active' : ''} onClick={() => onSelect('application-bin')}><span>Job Applications Bin</span>{counts.deletedApplications > 0 && <em>{counts.deletedApplications}</em>}</button></li>
            </ul>}
          </li>
        </ul>
      </nav>
      {/* <div className="sidebar-help">
        <div className="help-icon">?</div>
        <div><strong>Need help?</strong><span>Visit support center</span></div>
      </div> */}
    </aside>
  );
}

export default Sidebar;
